"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWifiMediumOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M18 25a2.47 2.47 0 00-4 0l2 2zM16 20a5.48 5.48 0 014.56 2.44L22 21a7.47 7.47 0 00-12 0l1.43 1.43A5.48 5.48 0 0116 20z" }),
        React.createElement("path", { d: "M16 14a11.47 11.47 0 018.84 4.16l1.42-1.42a13.47 13.47 0 00-20.52 0l1.42 1.42A11.47 11.47 0 0116 14z" })));
}
exports.default = SvgWifiMediumOutline;
//# sourceMappingURL=WifiMediumOutline.js.map